import { C } from '../utils/constants';

export const ProgressBar = ({ completedDays }) => {
  const courseDays = 6;
  const total = 7; // Day 1–6 + Call Day
  const pct = Math.min((completedDays / courseDays) * 100, 100);
  const callDayReached = completedDays >= courseDays;

  // Items: indices 0–5 = Day 1–6, index 6 = Call Day
  const items = [
    ...Array.from({ length: courseDays }, (_, i) => ({ dayNum: i + 1, isCallDay: false })),
    { dayNum: 7, isCallDay: true },
  ];

  return (
    <div style={{
      background: '#fff',
      borderBottom: `1px solid ${C.border}`,
      padding: '14px 24px',
    }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>

        {/* Label row */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 10,
        }}>
          <span style={{
            fontFamily: "'Forum', serif",
            fontSize: '0.85rem',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: C.brown,
          }}>
            Your Journey
          </span>
          <span style={{
            fontSize: '0.8rem',
            color: C.terracotta,
            fontWeight: 600,
          }}>
            {completedDays} of {courseDays} days complete
          </span>
        </div>

        {/* Track */}
        <div style={{ position: 'relative', height: 8, marginBottom: 8 }}>
          {/* Background track */}
          <div style={{
            position: 'absolute',
            inset: 0,
            background: C.veryLightBrown,
            borderRadius: 4,
            border: `1px solid ${C.border}`,
          }} />
          {/* Filled portion */}
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            width: `${pct}%`,
            background: `linear-gradient(90deg, ${C.amber}, ${C.gold})`,
            borderRadius: 4,
            transition: 'width 0.6s ease',
            boxShadow: pct > 0 ? '0 0 8px rgba(245,166,35,0.5)' : 'none',
          }} />

          {/* Markers */}
          {items.map((item, i) => {
            const isComplete = !item.isCallDay && item.dayNum <= completedDays;
            const leftPct = (i / (total - 1)) * 100;
            return (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  left: `${leftPct}%`,
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: item.isCallDay ? 22 : 20,
                  height: item.isCallDay ? 22 : 20,
                  borderRadius: '50%',
                  background: isComplete
                    ? `linear-gradient(135deg, ${C.amber}, ${C.gold})`
                    : item.isCallDay && callDayReached
                    ? `linear-gradient(135deg, ${C.amber}, ${C.gold})`
                    : '#fff',
                  border: item.isCallDay
                    ? `2px solid ${C.gold}`
                    : isComplete
                    ? `2px solid ${C.gold}`
                    : `2px solid ${C.border}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: item.isCallDay ? '0.55rem' : '0.6rem',
                  color: (isComplete || (item.isCallDay && callDayReached))
                    ? '#fff'
                    : item.isCallDay
                    ? C.gold
                    : C.terracotta,
                  fontWeight: 700,
                  zIndex: 1,
                  transition: 'all 0.3s ease',
                  boxShadow: (isComplete || (item.isCallDay && callDayReached))
                    ? '0 0 6px rgba(245,166,35,0.5)'
                    : item.isCallDay
                    ? '0 0 4px rgba(245,166,35,0.3)'
                    : 'none',
                }}
              >
                {isComplete ? '✓' : item.isCallDay ? '★' : ''}
              </div>
            );
          })}
        </div>

        {/* Labels */}
        <div style={{ position: 'relative', height: 20, marginTop: 6 }}>
          {items.map((item, i) => (
            <span
              key={i}
              style={{
                position: 'absolute',
                left: `${(i / (total - 1)) * 100}%`,
                transform: 'translateX(-50%)',
                fontSize: '0.7rem',
                color: item.isCallDay
                  ? C.gold
                  : item.dayNum <= completedDays
                  ? C.amber
                  : C.terracotta,
                fontWeight: item.isCallDay || item.dayNum <= completedDays ? 700 : 400,
                opacity: item.isCallDay ? 1 : item.dayNum <= completedDays ? 1 : 0.6,
                whiteSpace: 'nowrap',
              }}
            >
              {item.isCallDay ? 'Call Day' : `D${item.dayNum}`}
            </span>
          ))}
        </div>

      </div>
    </div>
  );
};
